import { PageHero } from "../components/Shared";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../lib/useTitle";

const SECTIONS = [
  {
    title: "Our Commitment",
    body: "Bee Courageous @ Garden Grub is committed to ensuring that our website and our program are accessible to all women, including those with disabilities. We believe every person deserves equal access to hope, help, and community.",
  },
  {
    title: "Website Accessibility",
    body: "We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA. Our site is built with semantic structure, keyboard-navigable menus and forms, skip-to-content navigation, labeled form fields, sufficient color contrast, and reduced-motion support for visitors who prefer it.",
  },
  {
    title: "Program Accessibility",
    body: "Our gatherings are held in spaces selected with physical accessibility in mind, and we work individually with participants to accommodate mobility, sensory, dietary, and other needs. Participation is always free, removing financial barriers to healing.",
  },
  {
    title: "Feedback & Assistance",
    body: "If you experience any difficulty using this website or accessing our program, please contact us through the Contact page. Describe the barrier you encountered and the page or feature involved, and we will respond promptly and work to resolve it.",
  },
  {
    title: "Ongoing Effort",
    body: "Accessibility is a journey, not a destination. We review our site and practices regularly and welcome guidance from our community on how to serve every woman better.",
  },
];

export default function Accessibility() {
  useTitle("Accessibility Statement | Bee Courageous @ Garden Grub");
  return (
    <>
      <PageHero
        eyebrow="Accessibility Statement"
        lines={["Every woman,", "welcome here."]}
        lede="Our commitment to digital and physical accessibility across everything we do."
      />
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6 lg:py-28" data-testid="accessibility-content">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-charcoal/50">Last updated: July 2026</p>
        <div className="mt-8 space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={0.04 * i}>
              <h2 className="font-serif text-2xl font-semibold text-charcoal">{i + 1}. {s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-charcoal/75 sm:text-base">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
